import api from '@/api'

export default {
  all: (filter) => api('get', '/user', filter),
  create: (data) => api('post', '/user', data),
  show: (id) => api('get', `/user/${id}`),
  delete: (id) => api('delete', `/user/${id}`),
  update: (data) => api('put', `/user/${data.id}`, data),
  updatePassword: (data) => api('put', `/user/${data.id}/password`, data),
  resetSendLink: (data) => api('post', '/auth/reset/send-link', data),
  resetChangePassword: (data) => api('post', '/auth/reset/change-password', data)
}
